(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function(){
  var drawer = document.getElementById('CartDrawer');
  if (!drawer) return;

  var scrim   = document.getElementById('CartScrim');
  var itemsEl = document.getElementById('CartItems');
  var emptyEl = document.getElementById('CartEmpty');
  var footEl  = document.getElementById('CartFoot');
  var subEl   = document.getElementById('CartSubtotal');
  var shipEl  = document.getElementById('CartShip');
  var shipTxt = document.getElementById('CartShipText');
  var shipFill= document.getElementById('CartShipFill');
  var countEl = document.getElementById('CartCount');
  var closeB  = document.getElementById('CartClose');
  var cartBtn = document.getElementById('CartButton');

  var FMT = drawer.getAttribute('data-money-format') || '';
  var THRESHOLD = parseInt(drawer.getAttribute('data-threshold'), 10) || 0;
  var DRAWER_ON = drawer.getAttribute('data-drawer-enabled') === '1';
  var T = {
    freeReached: drawer.getAttribute('data-t-free-reached') || '',
    freeProgress: drawer.getAttribute('data-t-free-progress') || '',
    decrease: drawer.getAttribute('data-t-decrease') || '-',
    increase: drawer.getAttribute('data-t-increase') || '+',
    remove: drawer.getAttribute('data-t-remove') || '',
    error: drawer.getAttribute('data-t-error') || ''
  };
  var busy = false;
  var PACKS = (drawer.getAttribute('data-packs') || '').split(',').map(function(x){ return parseInt(x, 10) || 0; });
  var upEl = document.getElementById('CartUp'), upTxt = document.getElementById('CartUpText'), upBtn = document.getElementById('CartUpBtn');
  var discEl = document.getElementById('CartDisc');
  var UPV = [];
  try { UPV = JSON.parse(document.getElementById('CartUpVariants').textContent) || []; } catch (e) {}

  function esc(s){
    return String(s == null ? '' : s)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;').replace(/'/g,'&#39;');
  }

  function money(cents){
    var v = (cents / 100).toFixed(2).replace('.', ',');
    var parts = v.split(',');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var num = parts.join(',');
    if (FMT.indexOf('amount_no_decimals') > -1) {
      num = Math.round(cents / 100).toLocaleString('tr-TR');
    }
    var token = new RegExp('\{\{\s*amount[a-z_]*\s*\}\}', 'g');
    return FMT.replace(token, num) || (num + ' TL');
  }

  function open(){
    drawer.classList.add('is-open');
    scrim.classList.add('is-open');
    document.body.classList.add('cart-open');
  }
  function close(){
    drawer.classList.remove('is-open');
    scrim.classList.remove('is-open');
    document.body.classList.remove('cart-open');
  }
  window.moleyaCartOpen = open;

  function paintShipping(total){
    if (!shipEl || THRESHOLD <= 0) return;
    shipEl.hidden = false;
    var left = THRESHOLD - total;
    if (left <= 0) {
      shipTxt.textContent = T.freeReached;
      shipFill.style.width = '100%';
    } else {
      shipTxt.innerHTML = esc(T.freeProgress).replace('__AMT__', '<b>' + money(left) + '</b>');
      shipFill.style.width = Math.max(3, (total / THRESHOLD) * 100) + '%';
    }
  }

  function render(cart){
    if (countEl) {
      countEl.textContent = cart.item_count;
      countEl.classList.toggle('on', cart.item_count > 0);
    }
    if (!cart.items || !cart.items.length) {
      itemsEl.innerHTML = '';
      emptyEl.hidden = false;
      footEl.hidden = true;
      if (shipEl) shipEl.hidden = true;
      return;
    }
    emptyEl.hidden = true;
    footEl.hidden = false;

    var html = '';
    cart.items.forEach(function(it){
      var img = it.image
        ? '<img src="' + esc(it.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_160x$1')) + '" alt="' + esc(it.product_title) + '" width="72" height="82" loading="lazy">'
        : '';
      var variant = (it.variant_title && it.variant_title !== 'Default Title')
        ? '<span class="cd__var">' + esc(it.variant_title) + '</span>' : '';
      html +=
        '<div class="cd__row" data-key="' + esc(it.key) + '">' +
          '<a class="cd__img" href="' + esc(it.url) + '">' + img + '</a>' +
          '<div class="cd__info">' +
            '<a class="cd__name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
            variant +
            '<span class="cd__price">' + money(it.final_line_price) + '</span>' +
            '<div class="cd__ctrl">' +
              '<span class="cd__qty">' +
                '<button type="button" data-act="dec" aria-label="' + esc(T.decrease) + '"><svg viewBox="0 0 24 24"><path d="M5 12h14"/></svg></button>' +
                '<span>' + it.quantity + '</span>' +
                '<button type="button" data-act="inc" aria-label="' + esc(T.increase) + '"><svg viewBox="0 0 24 24"><path d="M12 5v14M5 12h14"/></svg></button>' +
              '</span>' +
              '<button type="button" class="cd__del" data-act="del">' +
                '<svg viewBox="0 0 24 24"><path d="M4 7h16"/><path d="M9 7V5.5A1.5 1.5 0 0 1 10.5 4h3A1.5 1.5 0 0 1 15 5.5V7"/><path d="M6.5 7l1 12a2 2 0 0 0 2 1.8h5a2 2 0 0 0 2-1.8l1-12"/></svg>' +
                esc(T.remove) +
              '</button>' +
            '</div>' +
          '</div>' +
        '</div>';
    });
    itemsEl.innerHTML = html;
    subEl.textContent = money(cart.total_price);

    /* paket indirimi satırı */
    var discs = cart.cart_level_discount_applications || [];
    if (discEl) {
      if (discs.length && cart.original_total_price > cart.total_price) {
        var dh = '<span>Ürünler</span><s>' + money(cart.original_total_price) + '</s>';
        discs.forEach(function(d){
          dh += '<span>Paket indirimi · ' + esc(d.title) + '</span><b>−' + money(d.total_allocated_amount) + '</b>';
        });
        discEl.innerHTML = dh;
        discEl.hidden = false;
      } else { discEl.hidden = true; }
    }

    /* bir sonraki pakete yükseltme önerisi */
    if (upEl) {
      var n = cart.item_count, unit = PACKS[0];
      var next = PACKS[n] || 0, cur = n === 1 ? unit : (PACKS[n - 1] || unit * n);
      if (unit > 0 && n >= 1 && n < PACKS.length && next > 0) {
        var inCart = cart.items.map(function(it){ return it.variant_id; });
        var pick = UPV.filter(function(v){ return v.a && inCart.indexOf(v.id) === -1; })[0]
          || UPV.filter(function(v){ return v.id === cart.items[0].variant_id; })[0];
        if (pick) {
          var per = Math.round(next / (n + 1) / 100) * 100;
          upTxt.innerHTML = next <= cur
            ? '<b>' + (n + 1) + '. toka bedava:</b> bir renk daha ekle, toplam değişmez'
            : '<b>+' + money(next - cur) + '</b> ile ' + (n + 1) + ' adet olsun, tanesi <b>' + money(per) + '</b>';
          upBtn.textContent = '+ ' + pick.t + ' ekle';
          upBtn.setAttribute('data-id', pick.id);
          upEl.hidden = false;
        } else { upEl.hidden = true; }
      } else { upEl.hidden = true; }
    }
    paintShipping(cart.total_price);
  }

  function fetchCart(){
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(c){ render(c); return c; });
  }
  window.moleyaCartRefresh = fetchCart;

  function change(key, qty){
    if (busy) return;
    busy = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function(r){ return r.json(); })
      /* change.js yanıtında indirim alanları eksik gelebiliyor; sepeti /cart.js ile tam oku */
      .then(function(){ return fetchCart(); })
      .catch(function(){})
      .then(function(){ busy = false; });
  }

  itemsEl.addEventListener('click', function(e){
    var btn = e.target.closest('[data-act]');
    if (!btn) return;
    var row = btn.closest('.cd__row');
    if (!row) return;
    var key = row.getAttribute('data-key');
    var cur = parseInt(row.querySelector('.cd__qty span').textContent, 10) || 1;
    var act = btn.getAttribute('data-act');
    if (act === 'inc') change(key, cur + 1);
    else if (act === 'dec') change(key, Math.max(0, cur - 1));
    else if (act === 'del') change(key, 0);
  });

  if (upBtn) upBtn.addEventListener('click', function(){
    var id = parseInt(upBtn.getAttribute('data-id'), 10);
    if (!id || busy) return;
    busy = true; upBtn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function(){ return fetchCart(); })
      .catch(function(){})
      .then(function(){ busy = false; upBtn.disabled = false; });
  });

  if (closeB) closeB.addEventListener('click', close);
  scrim.addEventListener('click', close);
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });

  if (DRAWER_ON && cartBtn) {
    cartBtn.addEventListener('click', function(e){
      e.preventDefault();
      open();
      fetchCart();
    });
  }

  /* Sepete ekle — /cart/add.js items[] ARRAY formati zorunlu */
  document.addEventListener('submit', function(e){
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    if (!DRAWER_ON) return;
    e.preventDefault();
    /* Hangi buton gönderdi? "Kapıda ödeme ile al" name="return_to" taşır;
       onunla gönderilince çekmeceyi açmak yerine doğrudan ödemeye gideriz.
       btn.form kullanılıyor çünkü PDP'deki buton formun DIŞINDA (form=""). */
    var btn = e.submitter || document.activeElement;
    if (!btn || btn.form !== form) { btn = form.querySelector('[type="submit"]'); }
    var odemeyeGit = !!(btn && btn.name === 'return_to');
    var idInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    /* ürün sayfasındaki paket seçimi her rengi ayrı satır olarak data-items'a yazar */
    var items = null;
    try { items = JSON.parse(form.getAttribute('data-items') || 'null'); } catch (err) {}
    if (!items || !items.length) {
      if (!idInput) { form.submit(); return; }
      items = [{ id: parseInt(idInput.value, 10), quantity: parseInt(qtyInput ? qtyInput.value : 1, 10) || 1 }];
    }
    if (btn) { btn.disabled = true; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function(r){ return r.json(); })
      .then(function(res){
        if (res.status && res.status !== 200) { throw new Error(res.description || res.message); }
        if (odemeyeGit) { window.location.href = '/checkout'; return null; }
        return fetchCart().then(open);
      })
      .catch(function(err){ alert(err.message || T.error); })
      .then(function(){ if (btn && !odemeyeGit) { btn.disabled = false; } });
  });

  fetchCart();
})();
  } catch(e) { console.error(e); }
})();

})();
